import type { FaireProductEntity } from "../../entity_types/product";

export const p_zj896b7mav: FaireProductEntity = {
  token: "p_zj896b7mav",
  type: "product",
  name: "Pink Star Princess Dress Up Kit - Dress Up - Kids Gift",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/9000bfced0ea2d7c45cc1c11445778c3cfb2689b3a439cb4ba698d1af0adaf6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53a44fa98bd0b95b2d866d8614cc8edbdb5dba39e0c6ec88354b641e670fb08a.jpeg",
    "https://cdn.faire.com/fastly/2c7c53cde6c36853be04732ad88766c60826b149b02325c7a3565281f032668c.jpeg",
    "https://cdn.faire.com/fastly/2a7773f3191c9685354afdb8509d0993c5be3556733160f2305308dd7657932f.jpeg",
    "https://cdn.faire.com/fastly/edb95ec8ce28a59e36f83ad80fc7b799ea4921505da996f6f7a16397c3971676.jpeg",
    "https://cdn.faire.com/fastly/54140c61aa6a7b96fd0debd1aec4417deb2ab70f1d77f3d865e6d2c9798566dc.jpeg",
    "https://cdn.faire.com/fastly/1fafb938288adf7ad2cf5f01e044e7eb0f392bdc034b1a450d09e9a765af930b.jpeg",
  ],
  priceDollars: 24,
  description:
    "Fit for the little princess who rules every kingdom with kindness, confidence, and plenty of sparkle. Sweet Wink dress up kits include everything a little one needs for the ultimate dress up ensemble. \n\nCapes are made with super soft tulle (that doesn’t scratch or itch!) and paired with a matching wand and glitter crown. This 3-piece set comes packaged on a white hanger card making it super easy to gift!\n\nIncludes:\n * 1 Cape: A soft pink glitter tulle cape with a scalloped hem and sparkling gold accents, made for royal entrances and magical adventures. The easy Velcro closure makes dress-up effortless. \n * 1 Wand: A glittering gold star wand with flowing satin ribbons, perfect for royal waves, magical wishes, and endless imaginative play. \n * 1 Crown Headband: A lightweight gold crown with a shimmering finish that's comfortable enough for all-day princess adventures.\n\nCape Features:\n * Velcro closure \n * One size fits children ages 3-6 years old \n * Dimensions: Neck-14 inches, Length-28 inches \n * Care: Hand wash only - do not iron, tumble dry, bleach, or dry clean \n\nSweet Wink is a mother-daughter business - all items are designed in their New York showroom and every order is packed with love by their team of local employees and shipped form their hometown warehouse.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:18.300Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
